export default "__VITE_ASSET__aadeca0d__"